<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">S<span class="smallcaps">TART</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-slowworm-song_00004.vue?48a76f22